import { IMAGES } from "../content";
import { Reveal, MaskedReveal } from "../motion";
import { Section, Wrap, Eyebrow } from "./Section";

const POINTS = [
  {
    n: "01",
    title: "A new venture, still unnamed",
    text: "The organisation is a new mental-health venture. Its name and identity are still to be developed: an opportunity to build meaning into the brand from the first day.",
  },
  {
    n: "02",
    title: "A broad offer, one calm front door",
    text: "Therapy, counselling, wellness, resources, events, schools, organisations and training. The platform must give each audience a clear pathway without forcing everyone through the same menu.",
  },
  {
    n: "03",
    title: "Trust before transaction",
    text: "The first release must create trust and generate suitable enquiries. Every design decision follows from that: dignity first, clarity always, pressure never.",
  },
  {
    n: "04",
    title: "One team, end to end",
    text: "Blank Space Media and StrateNova will develop the brand, content, imagery, user experience and website as a single, coherent piece of work.",
  },
];

export default function Understanding() {
  return (
    <Section id="understanding" theme="neutral" className="py-16 sm:py-24">
      <Wrap>
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16">
          <div className="lg:col-span-5">
            <Reveal>
              <Eyebrow>Our understanding</Eyebrow>
            </Reveal>
            <h2 className="font-serif font-light text-3xl sm:text-4xl lg:text-[2.9rem] leading-[1.12] tracking-tight mt-6 text-[#242424]">
              <MaskedReveal lines={["Before we propose", "a website, we sit", "with the brief."]} baseDelay={0.1} />
            </h2>
            <Reveal delay={2}>
              <p className="text-[#242424]/70 text-base sm:text-lg leading-relaxed mt-7 max-w-md">
                This is our reading of what the future organisation needs, offered as an interpretation, not a task list.
              </p>
            </Reveal>
            <Reveal delay={3} className="mt-10 hidden lg:block">
              <div className="relative overflow-hidden rounded-2xl">
                <img
                  src={IMAGES.wellnessRoom}
                  alt="A serene wellness room in morning light, opening onto a Table Mountain view"
                  className="w-full h-[340px] lg:h-[430px] object-cover transition-transform duration-700 hover:scale-[1.03]"
                  loading="lazy"
                />
              </div>
            </Reveal>
          </div>

          <div className="lg:col-span-7 lg:pt-16">
            <ol className="divide-y divide-[#242424]/10 border-t border-b border-[#242424]/10">
              {POINTS.map((p, i) => (
                <Reveal key={p.n} delay={i}>
                  <li className="grid sm:grid-cols-[auto_1fr] gap-3 sm:gap-10 py-8 group">
                    <span className="font-serif italic text-2xl text-[#B66E50]/70 group-hover:text-[#B66E50] transition-colors duration-500">{p.n}</span>
                    <div>
                      <h3 className="text-lg font-semibold tracking-tight text-[#242424]">{p.title}</h3>
                      <p className="text-[#242424]/65 leading-relaxed mt-2.5 max-w-xl">{p.text}</p>
                    </div>
                  </li>
                </Reveal>
              ))}
            </ol>
          </div>
        </div>
      </Wrap>
    </Section>
  );
}
